export function getAllFocusableElements(parent) {
  if (!parent) parent = document;

  const selectors = [
    'a[href]',
    'area[href]',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    'button:not([disabled])',
    'iframe',
    'object:not([tabindex="-1"])',
    'embed',
    '*[tabindex]:not([tabindex="-1"])',
    '*[contenteditable]',
  ];
  return parent.querySelectorAll(selectors.join(', '));
}

export function getNextFocusableElement(target, parent) {
  const allFocusableElements = getAllFocusableElements(parent);
  const currentElementIndex = Array.prototype.indexOf.call(allFocusableElements, target);
  if (currentElementIndex === -1) return;

  const nextElement = allFocusableElements[currentElementIndex + 1];
  if (!nextElement) return;

  return nextElement;
}

export function getPrevFocusableElement(target, parent) {
  const allFocusableElements = getAllFocusableElements(parent);
  const currentElementIndex = Array.prototype.indexOf.call(allFocusableElements, target);
  if (currentElementIndex === -1) return;

  const prevElement = allFocusableElements[currentElementIndex - 1];
  if (!prevElement) return;

  return prevElement;
}
